/** Konwersja treści prawnych (stary format / HTML) ↔ bloki BlockEditor (jak aktualności). */

export function emptyTextBlock() {
  return {
    type: 'text',
    text: '',
    align: 'left',
    bold: false,
    italic: false,
    underline: false,
  };
}

export function isEditorBlock(block) {
  return block != null && typeof block.type === 'string';
}

export function isEditorBlocksArray(arr) {
  return Array.isArray(arr) && arr.length > 0 && arr.every(isEditorBlock);
}

export function isLegacyLegalBlocksArray(arr) {
  return (
    Array.isArray(arr) &&
    arr.length > 0 &&
    arr.every((b) => b && typeof b.t === 'string' && typeof b.text === 'string')
  );
}

export function legacyLegalBlocksToEditorBlocks(legacyBlocks) {
  if (!Array.isArray(legacyBlocks)) return [emptyTextBlock()];
  const out = [];
  for (const b of legacyBlocks) {
    const text = String(b.text || '').trim();
    if (!text) continue;
    if (b.t === 'title') {
      out.push({ type: 'text', text, align: 'left', bold: true, italic: false, underline: false });
      continue;
    }
    if (b.t === 'subtitle') {
      out.push({ type: 'text', text, align: 'center', bold: true, italic: true, underline: false });
      continue;
    }
    if (b.t === 'section') {
      out.push({ type: 'text', text, align: 'left', bold: true, italic: false, underline: false });
      continue;
    }
    out.push({ type: 'text', text, align: 'left', bold: false, italic: false, underline: false });
  }
  return out.length > 0 ? out : [emptyTextBlock()];
}

export function htmlToEditorBlocks(html) {
  if (!html || typeof html !== 'string') return [emptyTextBlock()];
  let text = html
    .replace(/<\/?(h1|h2|p|br|li)[^>]*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\r/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  const lines = text.split('\n').map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return [emptyTextBlock()];
  return lines.map((line) => ({
    type: 'text',
    text: line,
    align: 'left',
    bold: false,
    italic: false,
    underline: false,
  }));
}

export function normalizeToEditorBlocks(raw, { legacyBlocks, html } = {}) {
  if (isEditorBlocksArray(raw)) {
    return raw.map((b) => ({ ...b }));
  }
  if (isLegacyLegalBlocksArray(raw)) {
    return legacyLegalBlocksToEditorBlocks(raw);
  }
  if (typeof raw === 'string' && raw.trim()) {
    return htmlToEditorBlocks(raw);
  }
  if (legacyBlocks) {
    return legacyLegalBlocksToEditorBlocks(legacyBlocks);
  }
  if (html) {
    return htmlToEditorBlocks(html);
  }
  return [emptyTextBlock()];
}

export function sanitizeEditorBlocksForSave(blocks) {
  if (!Array.isArray(blocks)) return [];
  return blocks.filter((block) => {
    if (!block || typeof block.type !== 'string') return false;
    if (block.type === 'text') return String(block.text || '').trim().length > 0;
    if (block.type === 'image') return !!String(block.url || '').trim();
    if (block.type === 'link') return !!String(block.url || block.text || '').trim();
    if (block.type === 'facebookVideo') return !!String(block.url || '').trim();
    if (block.type === 'divider') return true;
    return false;
  });
}
